import { render, staticRenderFns } from "./LeaveHospitalApproval.vue?vue&type=template&id=352b9252&scoped=true"
import script from "./LeaveHospitalApproval.vue?vue&type=script&lang=js"
export * from "./LeaveHospitalApproval.vue?vue&type=script&lang=js"
import style0 from "./LeaveHospitalApproval.vue?vue&type=style&index=0&id=352b9252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352b9252",
  null
  
)

export default component.exports